
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5f9a49f5!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AreaOverview.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AreaOverview.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5f9a49f5!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AreaOverview.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/AreaOverview.vue
// module id = 396
// module chunks = 0